import { Injectable, NgZone } from '@angular/core';
import { DzModalRef, DzModalService } from '@blk/daisy/modules/modals';

import { LoadingSpinnerComponent } from '../components/loading-spinner/loading-spinner.component';
import { ResponseMessageDialogComponent } from '../components/response-message-dialog/response-message-dialog.component';
import { PopupDialogObject } from '../models';

@Injectable()
export class ErrorPopupService {

	constructor(private zone: NgZone, private dzModalService: DzModalService) { }

	public openResponseMessageDialog(
		message: PopupDialogObject, disableClose: boolean = true, dialogWidth: string = '730px', size = 'md', shouldCloseAll: boolean = true
	): DzModalRef {
		let ref = null;
		this.zone.run(() => {
			if (shouldCloseAll) {
				this.dzModalService.closeAll();
			}
			if (message.title && message.showSpinner) {
				dialogWidth = '385px';
				size = 'sm';
				ref = this.dzModalService.open(LoadingSpinnerComponent, {
					contentData: {
						message: message,
						disableClose: message.disableClose || disableClose
					},
					size: size,
					style: {
						width: dialogWidth
					}
				});
			} else {
				ref = this.dzModalService.open(ResponseMessageDialogComponent, {
					contentData: {
						message: message,
						disableClose: message.disableClose || disableClose
					},
					showClose: !(message.disableClose || disableClose),
					size: size,
					// this is going to be there until we fix daisy modal to work properly with different widths
					style: { width: dialogWidth }
				});
			}
		});
		return ref;
	}

	public closeAllDialogs(): void {
		this.dzModalService.closeAll();
	}
}
